<template>
  <div class="c-button-line mb-6">
    <div v-for="(item, index) in items" v-bind:key="item.route.name">
      <v-btn large
        text
        x-large
        :to="item.route"
        active-class="c-button-line-btn__active"
        :exact="exact"
        :disabled="item.disabled"
      >
        {{ item.label }}
      </v-btn>
      <v-icon
        v-if="index !== items.length-1"
        color="#d6dbe4"
        class="mb-4 mx-1"
      >
        mdi-arrow-right
      </v-icon>
    </div>
  </div>
</template>

<script>
/**
 * Component ButtonLine.vue
 *
 * @module ButtonLine
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/ButtonLine.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "ButtonLine",
  props: {
    items: {
      type: Array,
    },
    exact: {
      type: Boolean,
      default: () => false,
    }
  },
};
</script>

<style lang="scss">
@import "../../../../scss/colors";

.c-button-line {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  .v-btn {
    background-color: map-get($coroColors, lightgray) !important;
    padding: 0 32px !important;
    margin-bottom: 16px;
    &:after {
      background-color: transparent;
    }
  }

  .c-button-line-btn__active {
    background-color: map-get($coroColors, purpleish) !important;
    opacity: 1;
    .v-btn__content {
      color: map-get($coroColors, purple);
    }
  }
}
</style>
